import React, {createRef} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Col, Row, Form, Input, Spin, Button, Modal, Typography, Checkbox } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import authAction from '../../../redux/auth/actions';
import IntlMessages from '../../../components/utility/intlMessages';
import { DvIntlMessages } from "../../../components/utility/dvGeneralUtilities";
import '../index.style.scss';
import bgImage from "../../../image/logo-admin-light.png";
import DvAnimateCss from "../../../components/uielements/dvAnimateCss";
import { some } from 'lodash';
import { useState } from 'react';

const FormItem = Form.Item;
const { login, loginWithOtp } = authAction;

function SignIn(props) {
  const otpBoxRefs = [0, 1, 2, 3].map((i) => createRef(i));
  const [username, setUsername] = useState(undefined);
  const [password, setPassword] = useState(undefined);
  const [rememberMe, setRememberMe] = useState(false);
  const [otpDigits, setOtpDigits] = useState([undefined, undefined, undefined, undefined]);
  const { loadingApp, is2faRequired } = props;
  

  const requestLogin = (values) => {
    const { login } = props;
    const { username, password, rememberMe } = values;
    if (username && password) {
      login(username, password, rememberMe);
    }
  };

  const isMobileOrTabletView = () => {
    return ["MobileView", "TabView"].includes(props.appView);
  };

  const getEmailAndPasswordStyle = () => {
    let style = {};
    if (isMobileOrTabletView()) {
      style = { marginLeft: "20px", width: "90%" };
    }
    return style;
  };

  const inputStyle = getEmailAndPasswordStyle();
  const signInButtonStyle = isMobileOrTabletView ? { marginRight: "22px" } : {};


  return (
    <Row type="flex" justify="center" align="middle" className="signInContainer" id="signInContainer" >
      <Col xs={24} sm={24} md={20} lg={18} xl={16}>

        <Row gutter={48}>

          <Col xs={24} sm={24} md={24} lg={{ span: 16, push: 8 }} xl={{ span: 16, push: 8 }}>
            <DvAnimateCss type="bounceInRight">
              <div className="isoLogoWrapper" style={{ background: `url(${bgImage})  no-repeat center center` }} />
            </DvAnimateCss>
          </Col>

          <Col xs={24} sm={24} md={24} lg={{ span: 8, pull: 16 }} xl={{ span: 8, pull: 16 }}>
            <Spin spinning={loadingApp}>
              <DvAnimateCss type="bounceInLeft">
                <Form className="isoSignInForm">

                  <div style={{ ...inputStyle }}>
                    <IntlMessages id="general.email" />
                    <FormItem
                      required={true}
                      >
                      <Input
                        size="large"
                        value={username}
                        onChange={e=>setUsername(e.target.value)}
                        placeholder={DvIntlMessages("general.email")}
                        prefix={<UserOutlined className="fadedIcon" />}
                      />
                    </FormItem>
                  </div>

                  <div style={{ ...inputStyle }}>
                    <div className="isoLeftRightComponent">
                      <IntlMessages id="signin.password" />
                    </div>
                    <FormItem
                      className={'passwordInput'}
                      required={true}
                    >
                      <Input.Password
                        size="large"
                        type="password"
                        value={password}
                        onChange={e=>setPassword(e.target.value)}
                        placeholder={DvIntlMessages("signin.password")}
                        prefix={<LockOutlined className="fadedIcon" />}
                      />

                    </FormItem>
                  </div>

                  <FormItem>
                    <Checkbox checked={rememberMe} onChange={e=>setRememberMe(e.target.checked)}><IntlMessages id="page.signInRememberMe"/></Checkbox>
                  </FormItem>

                  <Row type="flex" justify="end" align="middle">
                    <Col xs={12} sm={12} md={12} lg={12} xl={9}>
                      <div className="flexRight">
                        <Button htmlType='submit' type='primary'  style={{ ...signInButtonStyle }} onClick={()=>requestLogin({username, password, rememberMe})} >
                          <IntlMessages id="page.signInButton" />
                        </Button>
                      </div>
                    </Col>
                  </Row>

                </Form>
              </DvAnimateCss>

              <Modal
                  open={is2faRequired}
                  title={<IntlMessages id={'2fa.modal.title'} />}
                  footer={[<Button type='primary' disabled={some(otpDigits, otpDigit => otpDigit === undefined)} key="okButton" onClick={()=>{
                    const otp = this.state.otpDigits.join("");
                    props.loginWithOtp(username, password, rememberMe, otp);
                  }}><IntlMessages id="general.ok"/></Button>, null]}
                  style={{marginTop: "15%"}}
                  closable={false}
                  getContainer={()=>document.getElementById("signInContainer")}
                >
                  <Row type={'flex'} justify={'center'} align={'middle'}>
                    <React.Fragment>
                      <Typography.Paragraph>
                        <IntlMessages id={'2fa.usageDescription'} />
                      </Typography.Paragraph>
                    </React.Fragment>
                  </Row>
                  <Row type={'flex'} justify={'center'} align={'middle'}>
                    {otpDigits.map((otpDigit, boxIndex) => <Col key={boxIndex} lg={6}>
                      <Input
                        ref={otpBoxRefs[boxIndex]}
                        onChange={(event) => {
                          const digit = !isNaN(parseInt(event.target.value, 10)) ? parseInt(event.target.value, 10) : undefined;
                          if (digit !== undefined && boxIndex !== otpBoxRefs.length - 1) otpBoxRefs[boxIndex+1].current.focus();
                          const otpDigits = [...this.state.otpDigits];
                          otpDigits[boxIndex] =digit;
                          setOtpDigits(otpDigits);
                        }}
                        value={otpDigit}
                        style={{
                          width: '70px',
                          marginLeft: '20px'
                        }}
                        maxLength={1}
                      />
                    </Col>)}
                  </Row>
                </Modal>
            </Spin>
          </Col>

        </Row>

      </Col>
    </Row>
  );

}

SignIn.propTypes = {
  login:PropTypes.func.isRequired,
  loginWithOtp:PropTypes.func.isRequired,
  appView:PropTypes.string.isRequired,
  loadingApp:PropTypes.any.isRequired,
  is2faRequired: PropTypes.bool.isRequired
};

const mapActionsToProps = {
  login,
  loginWithOtp
};

function mapStateToProps(state) {
  return {
    loadingApp: state.Auth.get('loadingApp'),
    appView: state.App.get('view'),
    is2faRequired: state.Auth.get('is2faRequired')
  };
}

const connectedSignIn = connect(mapStateToProps, mapActionsToProps)(SignIn);
export { connectedSignIn as default };
